
import { defineComponent, ref } from 'vue'
import AP from './AP.vue'
// import IRR from './IRR.vue'
import PCRF from './PCRF.vue'
// import PONUM from './PONUM.vue'
import TCE from './TCE.vue'
import canView from '../../../../classes/view_checker'

export default defineComponent({
    components: {
        AP,
        // IRR,
        PCRF,
        // PONUM,
        TCE,
    },
    setup(){
        const name = ref('IBPS Data')
        
        return {
            name,
            canView
        }
    }
});

